package com.example.mystybag.common.model

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString

data class DualTextInputBSVisualModel(
    val initialText1    : String                                = "",
    val initialText2    : String                                = "",
    val title           : String                                = "",
    val hint1           : String                                = "",
    val hint2           : String                                = "",
    val buttonText      : String                                = sharedString(SR.strings.save),
    val validate        : ((String, String) -> Pair<Boolean, String?>)? = null,
    val onTextChanged   : (String, String) -> Unit              = { _, _ -> }
)
